import React from 'react';
import { Flame } from 'lucide-react';
export function Footer() {
  return <footer className="bg-stone-950 text-stone-400 py-12 border-t border-stone-800" data-id="element-85">
      <div className="max-w-6xl mx-auto px-4 md:px-6 flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-86">
        <div className="flex items-center gap-2 text-white font-heading font-bold text-xl tracking-tight" data-id="element-87">
          <Flame className="w-6 h-6 text-brand-500" strokeWidth={2.5} data-id="element-88" />
          <span data-id="element-89">CRUNCHY FIT</span>
        </div>

        <p className="text-sm text-center md:text-left" data-id="element-90">
          © {new Date().getFullYear()} Crunchy Fit. Todos los derechos
          reservados.
        </p>

        <div className="flex gap-6 text-sm" data-id="element-91">
          <a href="#" className="hover:text-white transition-colors" data-id="element-92">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-93">
            Política de Privacidad
          </a>
        </div>
      </div>
    </footer>;
}